import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=2191c89a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2191c89a')) {
      api.createRecord('2191c89a', component.options)
    } else {
      api.reload('2191c89a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=2191c89a&", function () {
      api.rerender('2191c89a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MDeaRmsC4qOw/JS/pricehelp.vue"
export default component.exports